import { createFocusTrap } from 'focus-trap'
import Keyboard from '../utils/keyboard'

export class Modal {
  /**
   *
   * @param {Element} el
   * @param {Boolean} ephemeral
   */
  constructor(el, ephemeral = false) {
    this.modal = el
    this.id = this.modal.getAttribute('id')
    this.track = this.modal.getAttribute('data-track')
    this.closeButton = this.modal.querySelector('.modal__close')
    this.focusTrap = null
    this.prevEl = null
    this.isOpen = false
    this.ephemeral = ephemeral
    this.buttons = this.id
      ? document.querySelectorAll(`
      [data-modal='${this.id}']`)
      : []

    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.destroy = this.destroy.bind(this)

    this.init()
  }

  /**
   * Toggle Modal Open Status
   */
  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  /**
   * Open the Modal
   */
  open(e) {
    if (this.isOpen) return

    const { target } = e
    this.prevEl = target

    this.modal.classList.add('modal--open')
    document.body.style.overflow = 'hidden'

    setTimeout(() => {
      this.focusTrap = createFocusTrap(this.modal, {
        initialFocus: this.modal,
      })
      this.focusTrap.activate()
    }, 200)

    if (this.track && window.dataLayer) {
      window.dataLayer.push({
        event: this.track,
      })
    }

    this.isOpen = true
  }

  /**
   * Closes the Modal
   */
  close() {
    if (!this.isOpen) return

    this.modal.classList.remove('modal--open')
    document.body.removeAttribute('style')

    if (this.ephemeral) {
      setTimeout(this.destroy, 200)
    }

    if (this.focusTrap) {
      this.focusTrap.deactivate()
      this.focusTrap = null
    }

    if (this.prevEl) {
      this.prevEl.focus()
      this.prevEl = null
    }

    this.isOpen = false
  }

  /**
   * Destroy the instance
   */
  destroy() {
    if (this.focusTrap) {
      this.focusTrap.deactivate()
      this.focusTrap = null
    }
    this.modal.remove()
  }

  /**
   * Init Modal
   */
  init() {
    // Button Open
    if (this.buttons.length) {
      this.buttons.forEach(button => {
        button.addEventListener('click', this.open)
      })
    }

    // Esc Key Close
    Keyboard.up('Escape', this.close)
    Keyboard.down('Escape', this.close)

    // Outside Dialog click close
    this.modal.addEventListener('click', e => {
      const { target } = e

      if (target === this.modal) {
        this.close()
      }
    })

    // Close on Form Success
    document.addEventListener('form-success', this.close)

    // Close Button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close)
    }
  }
}

const modalInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.modal')
    Array.from(wrapperEl).forEach(el => {
      // eslint-disable-next-line no-new
      new Modal(el)
    })
  },
}

export default modalInit
